export const isDateEmpty = (data: string) => {
    if(!data || data.includes('NaN')){
        return true
    }
    return false
}